import { render, staticRenderFns } from "./MultipleChoiceTextQuestionTextAnswer.vue?vue&type=template&id=6d2235c4"
import script from "./MultipleChoiceTextQuestionTextAnswer.vue?vue&type=script&lang=js"
export * from "./MultipleChoiceTextQuestionTextAnswer.vue?vue&type=script&lang=js"
import style0 from "./MultipleChoiceTextQuestionTextAnswer.vue?vue&type=style&index=0&id=6d2235c4&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports